import React from "react";
import teacher_1 from "../../assets/images/pt01.jpg";
import teacher_2 from "../../assets/images/pt02.jpg";
import teacher_3 from "../../assets/images/pt03.jpg";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import Tooltip from "@mui/material/Tooltip";
const HomePageTeam = () => {
  return (
    <div className=" z-10 w-full flex justify-center pt-[60px] pb-[120px] overflow-hidden items-center relative mb-36 bg-[#D6ECE1]">
      <div
        className="absolute -bottom-[1px] rotate-180 overflow-hidden w-full"
        data-negative="false"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 100"
          className="h-[105px] transform -z[1] -translate-x-1/2 block relative left-1/2"
          style={{
            width: "calc(300% + 1.3px",
            transform: " translateX(-50%) rotateY(180deg)",
          }}
          preserveAspectRatio="none"
        >
          <path
           className="transform"
           style={{ transform: 'rotateY(0deg)', transformOrigin: 'center' }}
            opacity="0.33" fill="#fff"
            d="M473,67.3c-203.9,88.3-263.1-34-320.3,0C66,119.1,0,59.7,0,59.7V0h1000v59.7 c0,0-62.1,26.1-94.9,29.3c-32.8,3.3-62.8-12.3-75.8-22.1C806,49.6,745.3,8.7,694.9,4.7S492.4,59,473,67.3z"
          ></path>
          <path
         className="transform" fill= "#fff"
         style={{ transform: 'rotateY(0deg)', transformOrigin: 'center' }}
            opacity="0.66"
            d="M734,67.3c-45.5,0-77.2-23.2-129.1-39.1c-28.6-8.7-150.3-10.1-254,39.1 s-91.7-34.4-149.2,0C115.7,118.3,0,39.8,0,39.8V0h1000v36.5c0,0-28.2-18.5-92.1-18.5C810.2,18.1,775.7,67.3,734,67.3z"
          ></path>
          <path
           className="transform" fill="#fff" 
           style={{ transform: 'rotateY(0deg)', transformOrigin: 'center' }}
            d="M766.1,28.9c-200-57.5-266,65.5-395.1,19.5C242,1.8,242,5.4,184.8,20.6C128,35.8,132.3,44.9,89.9,52.5C28.6,63.7,0,0,0,0 h1000c0,0-9.9,40.9-83.6,48.1S829.6,47,766.1,28.9z"
          ></path>
        </svg>{" "}
      </div>
      <div className="xl:w-[75%] w-[90%] flex items-center md:pb-20 pb-10 flex-col gap-3 text-center ">
        <div className=" text-[#cfa649] text-2xl font-playfair"> Teachers</div>
        <h2 className="text-[#17543E] text-4xl font-bold font-playfair">
          Practice with confidence
        </h2>
        <div className="w-full flex flex-col md:gap-2 lg:gap-0 mb-4 md:flex-row">
          <div className="md:w-1/3  w-full p-3 md:p-0 lg:p-6">
            <div className="flex flex-col w-full bg-white border-[1px] my-6">
              <div className="w-full ">
                <img
                  src={teacher_1}
                  alt="practice_img_1"
                  className="object-cover"
                />
              </div>
              <div className="lg:px-6 lg:py-3 md:p-2 p-3 flex justify-center items-center flex-col gap-1 border-b-[1px]">
                <h3 className="text-[32px] font-playfair text-[#17543e] font-bold">
                  {" "}
                  Vannessa 
                </h3>
                <p className="text-[17px] text-[#17543E] font-playfair opacity-70 fon-bold">
                  Meditation Trainer
                </p>
              </div>

              <div className="flex justify-center flex-row gap-10 py-6 items-center">
                <Tooltip
                  title="Facebook"
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        fontSize: "16px",
                        padding: "8px 14px",
                        backgroundColor: "#17543e", // optional custom bg
                        color: "#fff", // optional text color
                        borderRadius: "8px",
                      },
                    },
                  }}
                >
                  <a href="/">
                    <FacebookOutlinedIcon className="text-[18px] text-[#cfa649]" />
                  </a>
                </Tooltip>

                <Tooltip
                  title="Twitter / X"
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        fontSize: "16px",
                        padding: "8px 14px",
                        backgroundColor: "#17543e", // optional custom bg
                        color: "#fff", // optional text color
                        borderRadius: "8px",
                      },
                    },
                  }}
                >
                  <a href="/">
                    <XIcon className="text-[18px] text-[#cfa649]" />
                  </a>
                </Tooltip>

                <Tooltip
                  title="LinkedIn"
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        fontSize: "16px",
                        padding: "8px 14px",
                        backgroundColor: "#17543e", // optional custom bg
                        color: "#fff", // optional text color
                        borderRadius: "8px",
                      },
                    },
                  }}
                >
                  <a href="/">
                    <LinkedInIcon className="text-[18px] text-[#cfa649]" />
                  </a>
                </Tooltip>

                <Tooltip
                  title="Instagram"
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        fontSize: "16px",
                        padding: "8px 14px",
                        backgroundColor: "#17543e", // optional custom bg
                        color: "#fff", // optional text color
                        borderRadius: "8px",
                      },
                    },
                  }}
                >
                  <a href="/">
                    <InstagramIcon className="text-[18px] text-[#cfa649]" />
                  </a>
                </Tooltip>
              </div>
            </div>
          </div>
          <div className="md:w-1/3  w-full p-3 md:p-0 lg:p-6">
            <div className="flex flex-col w-full bg-white border-[1px] my-6">
              <div className="w-full ">
                <img
                  src={teacher_3}
                  alt="practice_img_1"
                  className="object-cover"
                />
              </div>
              <div className="lg:px-6 lg:py-3 md:p-2 p-3 flex justify-center items-center flex-col gap-1 border-b-[1px]">
                <h3 className="text-[32px] font-playfair text-[#17543e] font-bold">
                  {" "}
                  Yvone Wright
                </h3>
                <p className="text-[17px] text-[#17543E] font-playfair opacity-70 fon-bold">
                  Yoga Trainer
                </p>
              </div>

              <div className="flex justify-center flex-row gap-10 py-6 items-center">
                <Tooltip
                  title="Facebook"
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        fontSize: "16px",
                        padding: "8px 14px",
                        backgroundColor: "#17543e", // optional custom bg
                        color: "#fff", // optional text color
                        borderRadius: "8px",
                      },
                    },
                  }}
                >
                  <a href="/">
                    <FacebookOutlinedIcon className="text-[18px] text-[#cfa649]" />
                  </a>
                </Tooltip>

                <Tooltip
                  title="Twitter / X"
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        fontSize: "16px",
                        padding: "8px 14px",
                        backgroundColor: "#17543e", // optional custom bg
                        color: "#fff", // optional text color
                        borderRadius: "8px",
                      },
                    },
                  }}
                >
                  <a href="/">
                    <XIcon className="text-[18px] text-[#cfa649]" />
                  </a>
                </Tooltip>

                <Tooltip
                  title="LinkedIn"
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        fontSize: "16px",
                        padding: "8px 14px",
                        backgroundColor: "#17543e", // optional custom bg
                        color: "#fff", // optional text color
                        borderRadius: "8px",
                      },
                    },
                  }}
                >
                  <a href="/">
                    <LinkedInIcon className="text-[18px] text-[#cfa649]" />
                  </a>
                </Tooltip>

                <Tooltip
                  title="Instagram"
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        fontSize: "16px",
                        padding: "8px 14px",
                        backgroundColor: "#17543e", // optional custom bg
                        color: "#fff", // optional text color
                        borderRadius: "8px",
                      },
                    },
                  }}
                >
                  <a href="/">
                    <InstagramIcon className="text-[18px] text-[#cfa649]" />
                  </a>
                </Tooltip>
              </div>
            </div>
          </div>
          <div className="md:w-1/3  w-full p-3 md:p-0 lg:p-6">
            <div className="flex flex-col w-full bg-white border-[1px] my-6">
              <div className="w-full ">
                <img
                  src={teacher_2}
                  alt="practice_img_1"
                  className="object-cover"
                />
              </div>
              <div className="lg:px-6 lg:py-3 md:p-2 p-3 flex justify-center items-center flex-col gap-1 border-b-[1px]">
                <h3 className="text-[32px] font-playfair text-[#17543e] font-bold">
                  {" "}
                  Bruce Palmer
                </h3>
                <p className="text-[17px] text-[#17543E] font-playfair opacity-70 fon-bold">
                  Fitness Trainer
                </p>
              </div>

              <div className="flex justify-center flex-row gap-10 py-6 items-center">
                <Tooltip
                  title="Facebook"
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        fontSize: "16px",
                        padding: "8px 14px",
                        backgroundColor: "#17543e", // optional custom bg
                        color: "#fff", // optional text color
                        borderRadius: "8px",
                      },
                    },
                  }}
                >
                  <a href="/">
                    <FacebookOutlinedIcon className="text-[18px] text-[#cfa649]" />
                  </a>
                </Tooltip>

                <Tooltip
                  title="Twitter / X"
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        fontSize: "16px",
                        padding: "8px 14px",
                        backgroundColor: "#17543e", // optional custom bg
                        color: "#fff", // optional text color
                        borderRadius: "8px",
                      },
                    },
                  }}
                >
                  <a href="/">
                    <XIcon className="text-[18px] text-[#cfa649]" />
                  </a>
                </Tooltip>

                <Tooltip
                  title="LinkedIn"
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        fontSize: "16px",
                        padding: "8px 14px",
                        backgroundColor: "#17543e", // optional custom bg
                        color: "#fff", // optional text color
                        borderRadius: "8px",
                      },
                    },
                  }}
                >
                  <a href="/">
                    <LinkedInIcon className="text-[18px] text-[#cfa649]" />
                  </a>
                </Tooltip>

                <Tooltip
                  title="Instagram"
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        fontSize: "16px",
                        padding: "8px 14px",
                        backgroundColor: "#17543e", // optional custom bg
                        color: "#fff", // optional text color
                        borderRadius: "8px",
                      },
                    },
                  }}
                >
                  <a href="/">
                    <InstagramIcon className="text-[18px] text-[#cfa649]" />
                  </a>
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default HomePageTeam;
